import styled from 'styled-components';

const SelectWrapper = styled.div`
  margin-bottom: 30px;
`;

SelectWrapper.displayName = 'SelectWrapper';

export default SelectWrapper;
